// import { useEffect } from "react";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
// import { useHistory } from "react-router";
// import { endPoints } from "../../config/end-points";
// import useHttp from "../../hooks/use-http";
// import { cuteToast } from "../UI/cute";
import Input from "../UI/Input";
import UploadService from "../../Services/FileUploadServices";


const UploadAssetsForm = () => {
    
    const AepInputFileRef = useRef(null);
    const ThumbInputFileRef = useRef(null);
    const PrevInputFileRef = useRef(null);
    const bgImgInputFileRef = useRef(null);
    const bgVidInputFileRef = useRef(null);
    const [progressAEP, setProgressAEP] = useState(0);
    const [progressThumb, setProgressThumb] = useState(0);
    const [progressPrev, setProgressPrev] = useState(0);
    const [progressBgImg, setProgressBgImg] = useState(0);
    const [progressBgVid, setProgressBgVid] = useState(0);

    const [currentFile, setCurrentFile] = useState(undefined);
    const token = useSelector((state) => state.auth.token);


    const onDivClick = (ref) => {
        ref.current.click();
      };

    const [ slide, setslide] = useState({
        temp_name: "",
        slide_Name: "",
    });

    const [invalid, setinvalid] = useState({
        border: '3px dotted red', padding: "10px 0px"
    });

    const oninputChange = async (e, name) => {
        setslide({ ...slide, [name]: e.target.value });
        console.log(slide);

        if( slide.temp_name.length > 0 && e.target.value.length > 0 && e.target.value.includes('pq_slide_')){
            AepInputFileRef.current.disabled = false;
            ThumbInputFileRef.current.disabled = false;
            PrevInputFileRef.current.disabled = false;
            bgImgInputFileRef.current.disabled = false;
            bgVidInputFileRef.current.disabled = false;
            setinvalid({border: '3px dotted green', padding: "10px 0px"})
        }else{
            AepInputFileRef.current.disabled = true;
            ThumbInputFileRef.current.disabled = true;
            PrevInputFileRef.current.disabled = true;
            bgImgInputFileRef.current.disabled = true;
            bgVidInputFileRef.current.disabled = true;
            setinvalid({border: '3px dotted red', padding: "10px 0px"})
        }
    };

    const onfileChange = (e,file_name, setProgress) => {
        let currentFiles = e.target.files;
        setProgress(0);
        setCurrentFile(currentFiles);
        console.log(file_name);
    
        if (1) {
            
          UploadService.uploadAssets(currentFiles[0], slide , file_name, token, (event) => {
            setProgress(Math.round((100 * event.loaded) / event.total));
          })
            .then((response) => {
              // console.log(response.status);
              console.log(response.data.url);
            })
            .catch(() => {
                setProgress(0);
              // setMessage("Could not upload the file!");
              setCurrentFile(undefined);
            });
    
        }

      };

  

  return (
    <>
      <form >
        <div className="row">
        <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Template Name</label>
              <Input
                type="text"
                placeholder="Enter Slide Name"
                inputClass="form-control"
                onChange={(e) =>
                    // setslide({ ...slide, temp_name: e.target.value })
                    oninputChange(e, 'temp_name')
                }
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Slide Name</label>
              <Input
                type="text"
                name="slide_Name"
                placeholder="Enter Slide Name"
                inputClass="form-control"
                onChange={(e) =>
                    oninputChange(e, 'slide_Name')
                }
              />
            </div>
          </div>

        </div>
        <div className="row">     
                <div className="col-md-6 m-auto">
                    <div className="mb-3 ">
                    <label className="form-label mt-2"><b>AEP File</b></label>
                    <div
                        className="upload_thmnl mb-4 align-items-center uploadDiv text-center h80"
                        style={invalid}
                        onClick={ () => onDivClick(AepInputFileRef)}
                    >
                        <p className="text-primary"> <u>Click to upload</u> </p>
                        <p> <i>  <span>   (Upload AEP File)  </span> </i>  </p>
                        <br />
                        <input
                        name="aep"
                        ref={AepInputFileRef}
                        className="d-none"
                        type="file"
                        onChange={(e) =>
                            onfileChange(e, 'AEP',setProgressAEP)
                        }
                        />
                        {currentFile && (
                        <div className="progress">
                            <div
                            className="progress-bar progress-bar-info progress-bar-striped"
                            role="progressbar"
                            aria-valuenow={progressAEP}
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style={{ width: progressAEP + "%" }}
                            >
                            {progressAEP}%
                            </div>
                        </div>
                        )}

                    </div>

                    </div>
                </div>
                <div className="col-md-6 m-auto"></div>
        </div>
        <div className="row">     
                <div className="col-md-6 m-auto">
                    <div className="mb-3 ">
                    <label className="form-label mt-2"><b>ThumbNail Image</b></label>
                    <div
                        className="upload_thmnl mb-4 align-items-center uploadDiv text-center h80"
                        style={invalid}
                        onClick={ () => onDivClick(ThumbInputFileRef)}
                    >
                        <p className="text-primary"> <u>Click to upload</u> </p>
                        <p> <i>  <span>   (Upload ThumbNail Image)  </span> </i>  </p>
                        <br />
                        <input
                        name="aep"
                        ref={ThumbInputFileRef}
                        className="d-none"
                        type="file"
                        onChange={(e) =>
                            onfileChange(e, 'thumb', setProgressThumb)
                        }
                        />
                        {currentFile && (
                        <div className="progress">
                            <div
                            className="progress-bar progress-bar-info progress-bar-striped"
                            role="progressbar"
                            aria-valuenow={progressThumb}
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style={{ width: progressThumb + "%" }}
                            >
                            {progressThumb}%
                            </div>
                        </div>
                        )}
                    </div>
                    </div>
                </div>

                <div className="col-md-6 m-auto">
                <div className="mb-3 ">
                <label className="form-label mt-2"><b>Preview Video</b></label>
                {/* <input
                    className={`form-control font12 `}
                    type="file"
                /> */}
                    <div
                        className="upload_thmnl mb-4 align-items-center uploadDiv text-center h80"
                        style={invalid}
                        onClick={ () => onDivClick(PrevInputFileRef)}
                    >
                        <p className="text-primary"> <u>Click to upload</u> </p>
                        <p> <i>  <span>   (Upload Preview Video)  </span> </i>  </p>
                        <br />
                        <input
                        name="aep"
                        ref={PrevInputFileRef}
                        className="d-none"
                        type="file"
                        onChange={(e) =>
                            onfileChange(e, 'prev', setProgressPrev)
                        }
                        />

                        {currentFile && (
                        <div className="progress">
                            <div
                            className="progress-bar progress-bar-info progress-bar-striped"
                            role="progressbar"
                            aria-valuenow={progressPrev}
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style={{ width: progressPrev + "%" }}
                            >
                            {progressPrev}%
                            </div>
                        </div>
                        )}

                    </div>
                
                </div>
            </div>
        </div>
        <div className="row">     
                <div className="col-md-6 m-auto">
                    <div className="mb-3 ">
                    <label className="form-label mt-2"><b>BackGround Image</b></label>
                    <div
                        className="upload_thmnl mb-4 align-items-center uploadDiv text-center h80"
                        style={invalid}
                        onClick={ () => onDivClick(bgImgInputFileRef)}
                    >
                        <p className="text-primary"> <u>Click to upload</u> </p>
                        <p> <i>  <span>   (Upload BackGround Image)  </span> </i>  </p>
                        <br />
                        <input
                        name="aep"
                        ref={bgImgInputFileRef}
                        className="d-none"
                        type="file"
                        onChange={(e) =>
                            onfileChange(e, 'bgImg', setProgressBgImg)
                        }
                        />
                        {currentFile && (
                        <div className="progress">
                            <div
                            className="progress-bar progress-bar-info progress-bar-striped"
                            role="progressbar"
                            aria-valuenow={progressBgImg}
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style={{ width: progressBgImg + "%" }}
                            >
                            {progressBgImg}%
                            </div>
                        </div>
                        )}
                    </div>
                    </div>
                </div>

                <div className="col-md-6 m-auto">
                <div className="mb-3 ">
                <label className="form-label mt-2"><b>BackGround Video</b></label>
                    <div
                        className="upload_thmnl mb-4 align-items-center uploadDiv text-center h80"
                        style={invalid}
                        onClick={ () => onDivClick(bgVidInputFileRef)}
                    >
                        <p className="text-primary"> <u>Click to upload</u> </p>
                        <p> <i>  <span>   (Upload BackGround Video)  </span> </i>  </p>
                        <br />
                        <input
                        name="aep"
                        ref={bgVidInputFileRef}
                        className="d-none"
                        type="file"
                        onChange={(e) =>
                            onfileChange(e, 'bgvid', setProgressBgVid)
                        }
                        />
                        {currentFile && (
                        <div className="progress">
                            <div
                            className="progress-bar progress-bar-info progress-bar-striped"
                            role="progressbar"
                            aria-valuenow={progressBgVid}
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style={{ width: progressBgVid + "%" }}
                            >
                            {progressBgVid}%
                            </div>
                        </div>
                        )}
                    </div>

                </div>
            </div>
        </div>

        <div className="row">
        <div className="col-md-12 mt-3">
            {/* <button type="reset" className="btn btn-danger">
              Reset
            </button> */}
            <button type="submit" className="btn pull-right">
              Save
            </button>
          </div>
        </div>
        
      </form>
    </>
  );
};

export default UploadAssetsForm;
